export default __webpack_public_path__ + "static/media/03.82e907b8.jpg";